import { bankApi } from "./authenticatedAxios";

export const getAllComponentsAcb = async () => {
  return bankApi.get(`/statusPage/${process.env.REACT_APP_STATUSPAGE_PAGE_ID_ACB}`).then(({ data }) => data.data);
};
